import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./sass/app.sass?vue&type=style&index=0&lang=sass&external"

const __exports__ = script;

export default __exports__